import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./mypcm/mypcm.module').then(m => m.MypcmModule)
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      useHash: true,
      // Don't perform initial navigation in iframes
       initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled'
       
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
